import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import commonActions from "../common/actions";
import candidatesActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import masterActions from "../master/action";
import authActions from "../auth/actions";
import Cookies from "js-cookie";
import { calculateDaysDifference, formatDate } from "../../utils/validations";
import {
  EncryptFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import { downloadBase64 } from "../../utils/downloadBase64";

const candidatesSaga = function* () {
  yield all([
    yield takeEvery(
      candidatesActions.PROFILE_PERSONAL_DETAILS_CREATION,
      profilePersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.GET_PROFILE_PERSONAL_DETAILS,
      getProfilePersonalDetails
    ),
    yield takeEvery(
      candidatesActions.PROFILE_ADDRESS_DETAILS_CREATION,
      addressPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_CATEGORY_DETAILS_CREATION,
      categoryPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EDUCATION_DETAILS_CREATION,
      educationPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EXAM_DETAILS_CREATION,
      examPersonalDetailsCreation
    ),

    yield takeEvery(
      candidatesActions.PROFILE_CERTIFICATES_DETAILS_CREATION,
      certificatesPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_UPLOADS_DETAILS_CREATION,
      uploadsPersonalDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.GET_ADDRESS_PERSONAL_DETAILS,
      getAddressPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_CATEGORY_PERSONAL_DETAILS,
      getCategoryPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_EDUCATION_PERSONAL_DETAILS,
      getEducationPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_EXAM_PERSONAL_DETAILS,
      getExamPersonalDetails
    ),
    yield takeEvery(
      candidatesActions.GET_CERTIFICATE_PERSONAL_DETAILS,
      getCertificatePersonalDetails
    ),
    yield takeEvery(
      candidatesActions.PROFILE_PERSONAL_DETAILS_DRAFT_CREATION,
      personalDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_ADDRESS_DETAILS_DRAFT_CREATION,
      personalAddressDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_CATEGORY_DETAILS_DRAFT_CREATION,
      personalCategoryDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EDUCATION_DETAILS_DRAFT_CREATION,
      personalEducationDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_EXAM_DETAILS_DRAFT_CREATION,
      personalExamDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_CERTIFICATE_DETAILS_DRAFT_CREATION,
      personalCertificatesDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.GRIEVANCE_QUERY_CREATION,
      grievanceQueryCreation
    ),
    yield takeEvery(
      candidatesActions.GET_QUERY_STATUS_BY_CANDIDATEID,
      getQueryStatusByCandidate
    ),
    yield takeEvery(
      candidatesActions.PROFILE_OTHER_DETAILS_CREATION,
      otherDetailsCreation
    ),
    yield takeEvery(
      candidatesActions.PROFILE_OTHER_DETAILS_DRAFT_CREATION,
      otherDetailsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.GET_OTHER_PERSONAL_DETAILS,
      getOtherDetails
    ),
    yield takeEvery(
      candidatesActions.PROFILE_UPLOADS_DETAILS_DRAFT_CREATION,
      uploadsDraftCreation
    ),
    yield takeEvery(
      candidatesActions.GET_UPLOAD_PERSONAL_DETAILS,
      getUploadDetails
    ),
    yield takeEvery(
      candidatesActions.GET_COURSE_UPLOAD_PERSONAL_DETAILS,
      getCourseUploadDetails
    ),
    yield takeEvery(candidatesActions.GET_PINCODE, getPincode),
    yield takeEvery(
      candidatesActions.GET_PINCODE_CORRESPONDENCE,
      getPincodeCorrespondence
    ),
    yield takeEvery(
      candidatesActions.GET_FULL_CANDIDATE_DETAILS,
      getFullCandidateDetails
    ),
    yield takeEvery(
      candidatesActions.GET_FULL_CANDIDATE_DETAIL,
      getFullCandidateDetail
    ),

    yield takeEvery(
      candidatesActions.COURSE_PERSONAL_DETAILS_CREATION,
      coursePersonaldetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_ADDRESS_DETAILS_CREATION,
      courseAddressdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_RESERVATION_DETAILS_CREATION,
      courseReservationdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_ACADEMIC_DETAILS_CREATION,
      courseAcademicdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.COURSE_EXAM_DETAILS_CREATION,
      courseExamdetailsCreation
    ),
    yield takeEvery(
      candidatesActions.OTBS_COURSE_EXAM_DETAILS_CREATION,
      otbsCourseExamdetailsCreation
    ),

    yield takeEvery(
      candidatesActions.OTBS_UPDATE_COURSE_EXAM_DETAILS_CREATION,
      otbsUpdateCourseExamdetailsCreation
    ),

    yield takeEvery(
      candidatesActions.GET_COURSE_REGISTRATION_DETAILS,
      getAllCourseRegistrationDetails
    ),
    yield takeEvery(
      candidatesActions.GET_COURSE_ADDRESS_DETAILS,
      getCourseAddressDetails
    ),
    yield takeEvery(candidatesActions.GET_ALL_COURSE_LIST, getAllCourse),
    yield takeEvery(candidatesActions.GET_COURSE_TAB, getCourseTab),
    yield takeEvery(candidatesActions.GET_MASTER_FIELDS, getMasterFields),
    yield takeEvery(
      candidatesActions.GET_COURSE_ACTIVE_TAB,
      getCourseRegistrationActiveTab
    ),
    yield takeEvery(
      candidatesActions.GET_COURSE_APPLICANTID,
      getCourseApplicantId
    ),
    yield takeEvery(candidatesActions.GET_COURSE_STATUS, getCourseStatus),
    yield takeEvery(candidatesActions.GET_IS_PAID, getIsPaid),
    yield takeEvery(candidatesActions.GET_ALL_COURSE_CANDIDATE_IS_PAID, getAllcourseCandidateIsPaid),
    yield takeEvery(
      candidatesActions.GET_PAYMENT_RECEIPT_LIST,
      getPaymentReceiptList
    ),
    yield takeEvery(candidatesActions.GET_EXAM_STATE, getExamState),
    yield takeEvery(candidatesActions.GET_EXAM_DISTRICT, getExamDistrict),
    yield takeEvery(candidatesActions.GET_EXAM_LANGUAGE, getExamLanguage),
    yield takeEvery(
      candidatesActions.GET_OTBS_VENUE_DETAILS,
      getOtbsVenueDetails
    ),
    yield takeEvery(
      candidatesActions.GET_CURRENT_VENUE_DETAILS,
      getCurrentOtbsVenueDetails
    ),
    yield takeEvery(candidatesActions.GET_VENUE_DETAILS, getVenueDetails),
    yield takeEvery(
      candidatesActions.GET_FREE_VENUE_DETAILS,
      getFreecourseVenueDetails
    ),

    yield takeEvery(
      candidatesActions.GET_COURSE_FORM_DETAILS,
      getCourseFormDetails
    ),
    yield takeEvery(candidatesActions.GET_CURRENT_COURSE, getCurrentCourse),
    yield takeEvery(
      candidatesActions.COURSE_PREVIEW_UPDATION,
      updatePreviewandPaymentStatus
    ),
    yield takeEvery(candidatesActions.CREATE_PRINT_LOG, createPrintLog),
    yield takeEvery(candidatesActions.EDIT_COURSE_DETAILS, updateCourseDetails),
    yield takeEvery(candidatesActions.EDIT_COURSE_DETAILS, getIpAddress),
    yield takeEvery(candidatesActions.DOWLOAD_BROCHURE, downloadBrochure),
    yield takeEvery(
      candidatesActions.GET_CANDIDATE_COURSE_DETAILS,
      getcourseCandidateList
    ),
    yield takeEvery(candidatesActions.CREATE_DOWNLOAD_LOG, createDownloadLog),
    yield takeEvery(
      candidatesActions.CREATE_SCORECARD_DOWNLOAD_LOG,
      createscoreDownloadLog
    ),

    yield takeEvery(
      candidatesActions.ADMIT_AND_SCORE_CARD_VIEW_BUTTON_CLICK,
      AdmitAndScorecardViewButtonClick
    ),
    yield takeEvery(
      candidatesActions.FREE_REGISTRATION,
      Freecourseregistration
    ),
    yield takeEvery(candidatesActions.GET_ADMITCARD_URL, GetAdmitcardUrl),

    yield takeEvery(
      candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      getCoursePersonalInformationDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_RESERVATION_DETAILS,
      getCourseReservationDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_ACADEMIC_DETAILS,
      getCourseAcademicDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_EXAMCENTER_DETAILS,
      getCourseExamCenterDetails
    ),

    yield takeEvery(
      candidatesActions.GET_COURSE_EDITINGFACILITY_DETAILS,
      getCourseEditingFacilityDetails
    ),

     yield takeEvery(
      candidatesActions.GET_COURSE_PAYMENTINFORMATION_DETAILS,
      getCoursePaymentInformationDetails
    ),

  ]);
};

const getcourseCandidateList = function* ({ payload }) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const { courseid, candidateid } = payload;
    const result = yield call(() =>
      axios.get(
        `${API_URL}/master/coursemanagement/getstudentcourseCandidateList/${encodeURIComponent(
          EncryptFunction(courseid)
        )}/${encodeURIComponent(EncryptFunction(candidateid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });
    yield put({
      type: candidatesActions.SET_CANDIDATE_COURSE_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    yield delay(2000);
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getFullCandidateDetails = function* (data) {
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_FULL_CANDIDATE_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};
const getFullCandidateDetail = function* (data) {
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_FULL_CANDIDATE_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};

const getProfilePersonalDetails = function* () {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if (result) {
      yield put({
        type: candidatesActions.SET_PROFILE_PERSONAL_DETAILS,
        payload: decryptedData,
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCategoryPersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(
      async () =>
        await axios.get(`${API_URL}/candidate/registration/category/${12}`)
    );

    if (result) {
      yield put({
        type: candidatesActions.SET_CATEGORY_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
    }
  } catch (err) {}
};

const getAddressPersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/address/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`
      )
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if (result) {
      yield put({
        type: candidatesActions.SET_ADDRESS_PERSONAL_DETAILS,
        payload: decryptedData,
      });
      yield put({ type: masterActions.GET_STATE });
      if (decryptedData[0]?.pstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
          payload: {
            stateid: decryptedData[0]?.pstateid,
            type: "parmanent",
          },
        });
      }
      if (decryptedData[0]?.pdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_REGISTRATION,
          payload: {
            districtid: decryptedData[0]?.pdistrictid,
            type: "parmanent",
          },
        });
      }
      if (decryptedData[0]?.ptalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
          payload: {
            talukaid: decryptedData[0]?.ptalukaid,
            type: "parmanent",
          },
        });
      }
      yield delay(1000);
      if (decryptedData[0]?.cstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
          payload: {
            stateid: decryptedData[0]?.cstateid,
            type: "corespondence",
          },
        });
      }
      if (decryptedData[0]?.cdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_REGISTRATION,
          payload: {
            districtid: decryptedData[0]?.cdistrictid,
            type: "corespondence",
          },
        });
      }
      if (decryptedData[0]?.ctalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
          payload: {
            talukaid: decryptedData[0]?.ctalukaid,
            type: "corespondence",
          },
        });
      }

      if (decryptedData[0]?.pstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_COURSE,
          payload: {
            stateid: decryptedData[0]?.pstateid,
            type: "parmanent",
          },
        });
        yield delay(100);
      }
      if (decryptedData[0]?.pdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_COURSE,
          payload: {
            districtid: decryptedData[0]?.pdistrictid,
            type: "parmanent",
          },
        });
        yield delay(100);
      }
      if (decryptedData[0]?.ptalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_COURSE,
          payload: {
            talukaid: decryptedData[0]?.ptalukaid,
            type: "parmanent",
          },
        });
        yield delay(100);
      }
      yield delay(1000);
      if (decryptedData[0]?.cstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_COURSE,
          payload: {
            stateid: decryptedData[0]?.cstateid,
            type: "corespondence",
          },
        });
        yield delay(100);
      }
      if (decryptedData[0]?.cdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_COURSE,
          payload: {
            districtid: decryptedData[0]?.cdistrictid,
            type: "corespondence",
          },
        });
        yield delay(100);
      }
      if (decryptedData[0]?.ctalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_COURSE,
          payload: {
            talukaid: decryptedData[0]?.ctalukaid,
            type: "corespondence",
          },
        });
        yield delay(100);
      }
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getEducationPersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/candidate/registration/education/${candidateidid}`)
    );
    if (result) {
      yield put({
        type: candidatesActions.SET_EDUCATION_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getExamPersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/exampreference/${candidateidid}`
      )
    );
    if (result) {
      yield put({
        type: candidatesActions.SET_EXAM_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
    }
  } catch (err) {}
};

const getCertificatePersonalDetails = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/certificates/${candidateidid}`
      )
    );
    if (result) {
      yield put({
        type: candidatesActions.SET_CERTIFICATE_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
      yield put({ type: masterActions.GET_ALL_DISTRICT });
      if (result?.data?.result[0]?.ewsdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA,
          payload: result?.data?.result[0]?.ewsdistrictid,
        });
      }
    }
  } catch (err) {}
};

const profilePersonalDetailsCreation = function* (data) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = data;
  const { navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  try {
    const result = yield call(() =>
      axios.put(
        `${API_URL}/candidate/registration/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
        navigate("/mhcet/registration?page=address");
        yield put({
          type: authActions.GET_PROFILE_REGISTRATION_ACTIVE_TAB,
          payload: { id: candidateidid },
        });
      }
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/draft/personaldetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield put({ type: candidatesActions.GET_PROFILE_PERSONAL_DETAILS });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const addressPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });

    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/registration/address`, encodedData)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
        navigate("/mhcet/registration?page=otherdetails");
        yield put({
          type: authActions.GET_PROFILE_REGISTRATION_ACTIVE_TAB,
          payload: { id: candidateidid },
        });
      }
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalAddressDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const candidateidid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/draft/address/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const otherDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/registration/otherdetails`, encodedData)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      if (result?.data?.statusCode === 200) {
        navigate("/mhcet/registration?page=uploads");
        yield put({
          type: authActions.GET_PROFILE_REGISTRATION_ACTIVE_TAB,
          payload: { id: candidateidid },
        });
      }
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const otherDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const encodedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const candidateidid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/draft/otherdetails/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield put({ type: candidatesActions.GET_OTHER_PERSONAL_DETAILS });
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const getOtherDetails = function* () {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/otherdetails/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if (result) {
      yield put({
        type: candidatesActions.SET_OTHER_PERSONAL_DETAILS,
        payload: decryptedData,
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getUploadDetails = function* () {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateidid = yield select(
    (state) => state.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    if (candidateidid) {
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

      const result = yield call(() =>
        axios.get(
          `${API_URL}/candidate/registration/uploads/${encodeURIComponent(
            EncryptFunction(candidateidid)
          )}`
        )
      );
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.encryptedData,
      });
      if (result) {
        // const isSuccess = result?.data?.statusCode == 200;

        // if (isSuccess) {
        //   Cookies.set('uploaddetails', 'true', { expires: 7 }); // Expires in 7 days
        // }
        yield put({
          type: candidatesActions.SET_UPLOAD_PERSONAL_DETAILS,
          payload: result?.data?.statusCode === 200 ? decryptedData : [],
        });
      }
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const getCourseUploadDetails = function* (payload) {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const courseId = payload?.data?.courseid;
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/registration/courseuploads/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}/${encodeURIComponent(EncryptFunction(courseId))}`
        // `${API_URL}/candidate/registration/courseuploads/${candidateidid}/${courseId}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    if (result) {
      yield put({
        type: candidatesActions.SET_COURSE_UPLOAD_PERSONAL_DETAILS,
        payload: result?.data?.statusCode === 200 ? decryptedData : [],
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const categoryPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/registration/category`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=education");
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalCategoryDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/draft/category`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const educationPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/registration/education`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=exampreference");
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalEducationDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/draft/education`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const examPersonalDetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/registration/exampreference`,
        payload.data
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=certificates");
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalExamDetailsDraftCreation = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/draft/exampreference`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const certificatesPersonalDetailsCreation = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  const { navigate } = payload;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/registration/certificates`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      navigate("/mhcet/registration?page=uploads");
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const personalCertificatesDetailsDraftCreation = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/draft/certificates`, payload.data)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const uploadsPersonalDetailsCreation = function* (action) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = action;
  const { navigate, editStatus, coursename, courseid } = payload;
  const fileType = payload?.data?.filetype;
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const formData = new FormData();
    const photoFile = new File(
      [payload.data.photofilename],
      `${candidateidid}_photo.jpeg`,
      { type: "image/jpeg" }
    );
    const signFile = new File(
      [payload.data.signfilename],
      `${candidateidid}_signature.jpeg`,
      {
        type: "image/jpeg",
      }
    );
    const documentFile = new File(
      [payload.data.documentfilename],
      payload?.data?.documentfilename?.name,
      {
        type:
          fileType == "pdf"
            ? "application/pdf"
            : fileType == "jpg"
            ? "image/jpeg"
            : fileType == "png"
            ? "image/png"
            : fileType == "docx"
            ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            : fileType === "doc"
            ? "application/msword"
            : "",
      }
    );
    const operation = payload.data.operation;
    const candidateid = payload.data.candidateid;
    const documentid = payload.data.documentid;
    const status = payload.data.status;

    formData.append(
      "photofilename",
      payload?.data?.photofilename ? photoFile : ""
    );
    formData.append("signfilename", payload.data.signfilename ? signFile : "");
    formData.append(
      "documentfilename",
      payload.data.documentfilename ? documentFile : ""
    );

    formData.append(
      "photoUrl",
      payload?.data?.photofilename ? "" : payload?.data?.photoUrl
    );
    formData.append(
      "signUrl",
      payload?.data?.signfilename ? "" : payload?.data?.signUrl
    );
    formData.append(
      "docUrl",
      payload?.data?.documentfilename ? "" : payload?.data?.docUrl
    );

    formData.append(
      "photoname",
      payload?.data?.photoname ? payload?.data?.photoname : ""
    );
    formData.append(
      "signname",
      payload.data.signname ? payload.data.signname : ""
    );
    formData.append(
      "docname",
      payload.data.docname ? payload.data.docname : ""
    );

    formData.append("operation", operation);
    formData.append("candidateid", candidateid);
    formData.append("documentid", documentid);
    formData.append("status", status);
    formData.append(
      "frompreview",
      payload?.data?.fromPreview ? payload?.data?.fromPreview : "false"
    );
    formData.append("filetype", fileType ? fileType : "");

    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/registration/uploads/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    );
    if (result?.data?.statusCode === 200) {
      navigate(`/${localStorage.getItem("mhet_cnd_project")}/`);
      const queryParams = {
        courseid: courseid,
        coursename: coursename,
      };
      const encryptedParams = EncryptObjectFunction(queryParams);
      editStatus === 1
        ? navigate(
            `/${localStorage.getItem(
              "mhet_cnd_project"
            )}/editing-facility?c_data=${encryptedParams}`
          )
        : payload?.data?.fromPreview
        ? navigate(
            `/${localStorage.getItem(
              "mhet_cnd_project"
            )}/course-registration?page=preview&courseid=${EncryptFunction(
              payload?.data?.courseid
            )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
            {
              state: {
                courseid: payload?.data?.courseid,
                coursename: payload?.data?.coursename,
              },
            }
          )
        : navigate(`/${localStorage.getItem("mhet_cnd_project")}/home`);

      // if (!payload?.data?.fromPreview) {
      //   window.location.reload();
      // }
      // window.location.reload();
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: payload?.data?.fromPreview ? false : true,
        message: payload?.data?.fromPreview ? "" : result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const uploadsDraftCreation = function* (action) {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = action;
  const fileType = payload?.data?.filetype;
  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: true });
  try {
    const formData = new FormData();
    const photoFile = payload.data.photofilename
      ? new File([payload.data.photofilename], `${candidateidid}_photo.jpeg`, {
          type: "image/jpeg",
        })
      : null;
    const signFile = payload.data.signfilename
      ? new File(
          [payload.data.signfilename],
          `${candidateidid}_signature.jpeg`,
          {
            type: "image/jpeg",
          }
        )
      : null;
    const documentFile = payload.data.documentfilename
      ? new File(
          [payload.data.documentfilename],
          payload?.data?.documentfilename?.name,
          {
            type:
              fileType == "pdf"
                ? "application/pdf"
                : fileType == "jpg"
                ? "image/jpeg"
                : fileType == "png"
                ? "image/png"
                : fileType == "docx"
                ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                : fileType === "doc"
                ? "application/msword"
                : "",
          }
        )
      : null;

    const operation = payload.data.operation;
    const candidateid = payload.data.candidateid;
    const status = payload.data.status;

    formData.append(
      "photoUrl",
      payload?.data?.photofilename ? "" : payload?.data?.photoUrl
    );
    formData.append(
      "signUrl",
      payload?.data?.signfilename ? "" : payload?.data?.signUrl
    );
    formData.append(
      "docUrl",
      payload?.data?.documentfilename ? "" : payload?.data?.docUrl
    );

    formData.append(
      "photofilename",
      payload?.data?.photofilename ? photoFile : ""
    );
    formData.append("signfilename", payload.data.signfilename ? signFile : "");
    formData.append(
      "documentfilename",
      payload.data.documentfilename ? documentFile : ""
    );

    formData.append("operation", operation);
    formData.append("candidateid", candidateid);
    formData.append(
      "documentid",
      payload?.data?.documentid ? payload?.data?.documentid : ""
    );
    formData.append("status", status);

    formData.append("filetype", fileType ? fileType : "");

    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/draft/uploads/${encodeURIComponent(
          EncryptFunction(candidateidid)
        )}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    );

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    window.location.reload();
  } catch (err) {}

  yield put({ type: commonActions.SET_DRAFT_BUTTON_LOADER, payload: false });
};

const grievanceQueryCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  try {
    const formData = new FormData();

    for (let key in payload?.data) {
      formData.append(key, payload?.data[key]);
    }

    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/grievance/ticket`, formData)
    );
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    if (result?.data?.statusCode === 200) {
      navigate(`/${localStorage.getItem("mhet_cnd_project")}/query-list`);
    }
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getQueryStatusByCandidate = function* () {
  const candidateidid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/grievance/ticket/candidate/${candidateidid}`
      )
    );
    if (result?.data?.statusCode === 200) {
      let finalArr = result?.data?.result?.map((val, i) => {
        return {
          ...val,
          id: i + 1,
          noofdays: calculateDaysDifference(
            new Date(val?.createddate),
            new Date()
          ),
          ticketraisedon: formatDate(val?.createddate),
          status:
            val?.status === 1
              ? "Open"
              : val?.status === 5
              ? "Closed"
              : "Pending",
          ticketClosedOn: val?.status === 5 ? formatDate(val?.updateddate) : "",
        };
      });
      yield put({
        type: candidatesActions.SET_QUERY_STATUS_BY_CANDIDATEID,
        payload: finalArr,
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getPincode = function* (data) {
  try {
    const { payload } = data;
    const result = yield call(() =>
      axios.get(`${API_URL}/candidate/registration/pincode/${payload?.value}`)
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.SET_PINCODE,
        payload: result?.data?.result,
      });
      if (result?.data?.result[0]?.stateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
          payload: {
            stateid: result?.data?.result[0]?.stateid,
            type: "parmanent",
          },
        });
        yield put({
          type: masterActions.GET_DISTRICT,
          payload: result?.data?.result[0]?.stateid,
        });
      }
      if (result?.data?.result[0]?.districtid) {
        yield put({
          type: masterActions.GET_TALUKA,
          payload: result?.data?.result[0]?.districtid,
        });
        yield put({
          type: masterActions.GET_TALUKA_FOR_REGISTRATION,
          payload: {
            districtid: result?.data?.result[0]?.districtid,
            type: "parmanent",
          },
        });
      }
      if (result?.data?.result[0]?.talukaid) {
        yield put({
          type: masterActions.GET_VILLAGE,
          payload: result?.data?.result[0]?.talukaid,
        });
        yield put({
          type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
          payload: {
            talukaid: result?.data?.result[0]?.talukaid,
            type: "parmanent",
          },
        });
      }
    }
  } catch (err) {}
};

const getPincodeCorrespondence = function* (data) {
  console.log("getPincodeCorrespondence");

  try {
    const { payload } = data;
    const result = yield call(() =>
      axios.get(`${API_URL}/candidate/registration/pincode/${payload?.value}`)
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.SET_PINCODE_CORRESPONDENCE,
        payload: result?.data?.result,
      });
      if (result?.data?.result[0]?.stateid) {
        yield put({
          type: masterActions.GET_DISTRICT,
          payload: result?.data?.result[0]?.stateid,
        });
        yield put({
          type: masterActions.GET_DISTRICT_FOR_REGISTRATION,
          payload: {
            stateid: result?.data?.result[0]?.stateid,
            type: "corespondence",
          },
        });
      }
      if (result?.data?.result[0]?.districtid) {
        yield put({
          type: masterActions.GET_TALUKA,
          payload: result?.data?.result[0]?.districtid,
        });
        yield put({
          type: masterActions.GET_TALUKA_FOR_REGISTRATION,
          payload: {
            districtid: result?.data?.result[0]?.districtid,
            type: "corespondence",
          },
        });
      }
      if (result?.data?.result[0]?.talukaid) {
        yield put({
          type: masterActions.GET_VILLAGE,
          payload: result?.data?.result[0]?.talukaid,
        });
        yield put({
          type: masterActions.GET_VILLAGE_FOR_REGISTRATION,
          payload: {
            talukaid: result?.data?.result[0]?.talukaid,
            type: "corespondence",
          },
        });
      }
    }
  } catch (err) {}
};

const coursePersonaldetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/personaldetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
       yield put({
      type: candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: { courseid:payload?.data?.courseid },
    });

    if (result?.data?.statusCode === 200) {
      if (statusForRedirect === 1) {
        navigate(
          `/${localStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=preview&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      } else {
        navigate(
          `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
            payload?.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      }
      
      // window.location.reload();
  
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseAddressdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/addressdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
  
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }

       yield put({
      type: candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: { courseid:payload?.data?.courseid },
    });

    if (result?.data?.statusCode === 200) {
      if (statusForRedirect === 1) {
        navigate(
          `/${localStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=preview&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      } else {
        navigate(
          `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
            payload.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseAcademicdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/academicdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
   
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      
      yield delay(2000);

      
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }

 

   yield put({
      type: candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: { courseid:payload?.data?.courseid },
    });

    if (result?.data?.statusCode === 200) {
      if (statusForRedirect === 1) {
        navigate(
          `/${localStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=preview&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
        window.location.reload();
      } else {
        navigate(
          `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
            payload.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseReservationdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate, statusForRedirect } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/reservationdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
  

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    
      yield put({
      type: candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: { courseid:payload?.data?.courseid },
    });

    if (result?.data?.statusCode === 200) {
      if (statusForRedirect === 1) {
        navigate(
          `/${localStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=preview&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(payload?.data?.coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      } else {
        navigate(
          `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
            payload.nextPageName
          }`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: payload?.data?.coursename,
            },
          }
        );
      }
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const courseExamdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/examdetails/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`,
        encodedData
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
       yield put({
      type: candidatesActions.GET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: { courseid:payload?.data?.courseid },
    });

    if (result?.data?.statusCode === 200) {
      navigate(
        `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
          payload.nextPageName
        }`,
        {
          state: {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          },
        }
      );
      // window.location.reload();
    } else if (result?.data?.statusCode === 410) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 410 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const otbsCourseExamdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/venuedata/scheduler`, encodedData)
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: payload?.data?.courseid,
          },
        },
      });
      yield put({
        type: candidatesActions.GET_CURRENT_VENUE_DETAILS,
        payload: {
          courseid: payload?.data?.courseid,
          candidateid: payload?.data?.candidateid,
        },
      });
      // navigate(
      //   `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
      //     payload.nextPageName
      //   }`,
      //   {
      //     state: {
      //       courseid: payload?.data?.courseid,
      //       coursename: payload?.data?.coursename,
      //     },
      //   }
      // );
      // window.location.reload();
      navigate(
        `/${localStorage.getItem(
          "mhet_cnd_project"
        )}/course-registration?page=printapplication&&c_data=${EncryptObjectFunction(
          {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          }
        )}`,
        {
          state: {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          },
        }
      );
    }
    
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const getVenueDetails = function* (data) {
  const { payload } = data;
  const { setAvailable, navigate } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/venuedata/venue-allocation/${data?.payload?.courseid}/${data?.payload?.candidateid}/${data?.payload?.validtime}/${data?.payload?.venueid}`
      )
    );
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 400) {
      setAvailable(true);
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const getFreecourseVenueDetails = function* (data) {
  const { payload } = data;
  const { navigate, dispatch } = payload;
  const encodedData = yield call(handleEncodeJson, {
    encodeJSON: payload?.data,
  });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/venuedata/venue-allocation/${data?.payload?.courseid}/${data?.payload?.candidateid}/${data?.payload?.validtime}/${data?.payload?.venueid}`
      )
    );
    // if (result) {
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: result?.data?.statusCode === 200 ? "success" : "failed",
    //       show: true,
    //       message: result?.data?.message,
    //     },
    //   });
    //   yield delay(2000);
    //   yield put({
    //     type: commonActions.SET_ALERT,
    //     payload: {
    //       status: null,
    //       show: false,
    //       message: null,
    //     },
    //   });
    // }
    if (result?.data?.statusCode === 200) {
      dispatch({
        type: candidatesActions.FREE_REGISTRATION,
        payload: {
          courseid: data?.payload?.courseid,
          candidateid: data?.payload?.candidateid,
        },
      });
      navigate(
        `/${localStorage.getItem(
          "mhet_cnd_project"
        )}/course-registration?page=printapplication&&c_data=${EncryptObjectFunction(
          {
            courseid: data?.payload?.courseid,
            coursename: data?.payload?.coursename,
          }
        )}`,
        {
          state: {
            courseid: data?.payload?.courseid,
            coursename: data?.payload?.coursename,
          },
        }
      );
    } else {
      navigate(
        `/${localStorage.getItem(
          "mhet_cnd_project"
        )}/venue-allocation?courseid=${EncryptFunction(
          data?.payload?.courseid
        )}&coursename=${encodeURIComponent(data?.payload?.coursename)}`,
        {
          state: {
            courseid: data?.payload?.courseid,
            coursename: data?.payload?.coursename,
          },
        }
      );
      // dispatch({
      //   type: candidatesActions.FREE_REGISTRATION,
      //   payload: {
      //     courseid: data?.payload?.courseid,
      //     candidateid: data?.payload?.candidateid,
      //   },
      // });
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getAllCourseRegistrationDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_REGISTRATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseAddressDetails = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/courseaddressdetails/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    const { statusCode } = result?.data || {};
    yield put({
      type: candidatesActions.SET_COURSE_ADDRESS_DETAILS,
      payload: statusCode === 200 ? decryptedData : [],
    });

    if (statusCode === 200 && decryptedData?.length > 0) {
      const [
        { pstateid, pdistrictid, ptalukaid, cstateid, cdistrictid, ctalukaid },
      ] = decryptedData;

      yield delay(500);
      yield put({ type: masterActions.GET_STATE });
      if (pstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_COURSE,
          payload: { type: "parmanent", stateid: pstateid },
        });
        yield delay(100);
      }

      if (pdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_COURSE,
          payload: { type: "parmanent", districtid: pdistrictid },
        });
        yield delay(100);
      }

      if (ptalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_COURSE,
          payload: { type: "parmanent", talukaid: ptalukaid },
        });
      }

      if (cstateid) {
        yield put({
          type: masterActions.GET_DISTRICT_FOR_COURSE,
          payload: { type: "corespondence", stateid: cstateid },
        });
        yield delay(100);
      }

      if (cdistrictid) {
        yield put({
          type: masterActions.GET_TALUKA_FOR_COURSE,
          payload: { type: "corespondence", districtid: cdistrictid },
        });
        yield delay(100);
      }

      if (ctalukaid) {
        yield put({
          type: masterActions.GET_VILLAGE_FOR_COURSE,
          payload: { type: "corespondence", talukaid: ctalukaid },
        });
      }
    }
  } catch (err) {
    console.error("Error in getCourseAddressDetails saga", err);
  }
};

const getAllCourse = function* () {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_ALL_COURSE_LIST,
      payload: {
        all: result?.data?.statusCode === 200 ? decryptedData : [],
        filtered: result?.data?.statusCode === 200 ? decryptedData : [],
      },
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseTab = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/master/coursemanagement/form/tab/${payload?.data?.courseid}`
      )
    );
    yield put({
      type: candidatesActions.SET_COURSE_TAB,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getMasterFields = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/master/coursemanagement/form/field/${payload?.data?.courseid}`
      )
    );
    yield put({
      type: candidatesActions.SET_MASTER_FIELDS,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseRegistrationActiveTab = function* (data) {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/active-tab/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.data?.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_COURSE_ACTIVE_TAB,
      payload: result?.data?.statusCode === 200 ? decryptedData[0] : [],
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseApplicantId = function* (data) {
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield delay(1000);

  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/applicantid/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    // , {
    //   courseid: payload?.courseid,
    //   candidateid: payload?.candidateid,
    // }
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_APPLICANTID,
      payload: result?.data?.statusCode === 200 ? decryptedData : {},
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseStatus = function* (data) {
  const { payload } = data;
  
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/course-status/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_STATUS,
      payload: result?.data?.statusCode === 200 ? decryptedData[0] : [],
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

// const getIsPaid = function* (data) {
//   const { payload } = data;
//   yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
//   try {
//     const candidateid = yield select(
//       (state) => state?.authReducer?.candidateTokenDetails?.candidateid
//     );
//     const result = yield call(() =>
//       axios.post(
//         `${API_URL}/candidate/course/ispaid/${encodeURIComponent(
//           EncryptFunction(candidateid)
//         )}`,
//         {
//           candidateid: payload?.candidateid,
//           courseid: payload?.courseid,
//         }
//       )
//     );
//     const decryptedData = yield call(handleDecodeJSON, {
//       decodeJSON: result?.data?.result,
//     });

//     yield put({
//       type: candidatesActions.SET_IS_PAID,
//       payload: result?.data?.statusCode === 200 ? decryptedData : [],
//     });
//   } catch (err) {
//   }
//   yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
// };
const getIsPaid = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );

    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/ispaid/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_IS_PAID,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const getAllcourseCandidateIsPaid = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
console.log('payload---',payload);

    const result =  yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/candidateallcourseispaid/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}`
      )
    );
console.log('result---',result);

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
console.log('decryptedData--',decryptedData);

    yield put({
      type: candidatesActions.SET_ALL_COURSE_CANDIDATE_IS_PAID,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getPaymentReceiptList = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/paymentReceipt/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_PAYMENT_RECEIPT_LIST,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getExamState = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/exam-state`,
        payload?.data
      )
    );
    yield put({
      type: candidatesActions.SET_EXAM_STATE,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {}
};

const getExamDistrict = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/exam-district`,
        payload?.data
      )
    );
    yield put({
      type: candidatesActions.SET_EXAM_DISTRICT,
      payload:
        result?.data?.statusCode === 200
          ? { all: result?.data?.result, filtered: [] }
          : { all: [], filtered: [] },
    });
  } catch (err) {}
};

const getExamLanguage = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/exam-language`,
        payload?.data
      )
    );
    yield put({
      type: candidatesActions.SET_EXAM_LANGUAGE,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {}
};

const getCourseFormDetails = function* (data) {
  const { payload } = data;

  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/info/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_FORM_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
    if (decryptedData[0]?.pstateid) {
      yield put({
        type: masterActions.GET_DISTRICT,
        payload: decryptedData[0]?.pstateid,
      });
    }
    if (decryptedData[0]?.pdistrictid) {
      yield put({
        type: masterActions.GET_TALUKA,
        payload: decryptedData[0]?.pdistrictid,
      });
    }
    if (decryptedData[0]?.ptalukaid) {
      yield put({
        type: masterActions.GET_VILLAGE,
        payload: decryptedData[0]?.ptalukaid,
      });
    }
    if (decryptedData[0]?.cstateid) {
      yield put({
        type: masterActions.GET_DISTRICT,
        payload: decryptedData[0]?.cstateid,
      });
    }
    if (decryptedData[0]?.cdistrictid) {
      yield put({
        type: masterActions.GET_TALUKA,
        payload: decryptedData[0]?.cdistrictid,
      });
    }
    if (decryptedData[0]?.ctalukaid) {
      yield put({
        type: masterActions.GET_VILLAGE,
        payload: decryptedData[0]?.ctalukaid,
      });
      if (decryptedData[0]?.stateid) {
        yield put({
          type: masterActions.GET_DISTRICT,
          payload: decryptedData[0]?.stateid,
        });
      }
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCurrentCourse = function* (data) {
  const { payload } = data;

  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/singlecourse/${encodeURIComponent(
          EncryptFunction(payload?.courseid)
        )}/${encodeURIComponent(EncryptFunction(candidateid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_CURRENT_COURSE,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};

const updatePreviewandPaymentStatus = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  const { navigate, coursename, setEligibility, setFreecourse } = payload;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    const result = yield call(() =>
      axios.put(
        `${API_URL}/candidate/course/registraton/preview`,
        encryptedData
      )
    );

    if (result?.data?.statusCode === 200) {
      if (result?.data?.isTimeOver) {
        navigate(
          `/${localStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=examinationdetails&courseid=${EncryptFunction(
            payload?.data?.courseid
          )}&coursename=${encodeURIComponent(coursename)}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: coursename,
            },
          }
        );
      } else {
        navigate(
          `/${localStorage.getItem(
            "mhet_cnd_project"
          )}/course-registration?page=applicationfee&&c_data=${EncryptObjectFunction(
            { ...payload?.data, coursename: coursename }
          )}`,
          {
            state: {
              courseid: payload?.data?.courseid,
              coursename: coursename,
            },
          }
        );
      }

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    } else if (result?.data?.statusCode === 201) {
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result.data.result,
      });

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 201 ? "failed" : "success",
          show: true,
          message: decryptedData?.message,
          details: decryptedData?.details,
        },
      });

      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });

      setEligibility(true);

      yield put({
        type: candidatesActions.SET_ELIGIBILITY_DETAILS,
        payload: decryptedData?.details || [],
      });
    }
    if (result?.data?.statusCode === 700) {
      setFreecourse(true);
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const createPrintLog = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/print-log`,
        encryptedData
      )
    );
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const updateCourseDetails = function* (data) {
  const { payload } = data;
  const {
    navigate,
    isExtraFee,
    coursename,
    edit,
    subjectgroup,
    photofilename,
    signfilename,
  } = payload;
  try {
    const formData = new FormData();

    if (payload.data && typeof payload.data === "object") {
      Object.entries(payload.data).forEach(([key, value]) => {
        formData.append(key, value);
      });
    } else {
      console.error("Invalid payload.data structure", payload.data);
    }
    const photoFile = photofilename
      ? new File([photofilename], `${payload?.data?.candidateid}_photo.jpeg`, {
          type: "image/jpeg",
        })
      : null;
    const signFile = signfilename
      ? new File(
          [signfilename],
          `${payload?.data?.candidateid}_signature.jpeg`,
          { type: "image/jpeg" }
        )
      : null;

    formData.append("photofilename", photoFile || "");
    formData.append("signfilename", signFile || "");
    formData.append("photourl", photoFile ? "" : payload?.data?.photourl);
    formData.append("signurl", signFile ? "" : payload?.data?.signurl);

    const result = yield call(() =>
      axios.put(
        `${API_URL}/candidate/course/registraton/edit/${encodeURIComponent(
          EncryptFunction(payload?.data?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.data?.courseid))}`,
        formData
      )
    );
    if (result?.data?.statusCode === 200) {
      let encryptedData = {
        courseid: payload?.data?.courseid,
        isExtraFee: isExtraFee,
        coursename: coursename,
        edit: edit,
        subjectgroup: subjectgroup,
      };
      navigate(
        `/${localStorage.getItem(
          "mhet_cnd_project"
        )}/course-registration?page=preview&&c_data=${EncryptObjectFunction(
          encryptedData
        )}`
      );
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });

    yield put({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: "ELG",
        method: "eligibilitycriteriadetails",
      },
    });
  } catch (err) {}
};

const getIpAddress = function* () {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/candidate/course/registraton/ip`)
    );
    const decryptedData = yield call(handleEncodeJson, {
      decodeJSON: result?.data?.result,
    });

    yield put({
      type: candidatesActions.SET_IP_ADDRESS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};

const getOtbsVenueDetails = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/venuedata/otbsvenues/${payload?.courseid}/${payload?.candidateid}`
      )
    );
    yield put({
      type: candidatesActions.SET_OTBS_VENUE_DETAILS,
      payload:
        result?.data?.statusCode === 200
          ? {
              States: result?.data?.stateResult,
              Districts: result?.data?.districtResult,
              Venues: result?.data?.result,
            }
          : {
              States: [],
              Districts: [],
              Venues: [],
            },
    });
  } catch (err) {}
};

const getCurrentOtbsVenueDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);

  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/venue-allocation/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );

    if (result?.data?.statusCode == 200) {
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.result,
      });
      yield put({
        type: candidatesActions.SET_CURRENT_VENUE_DETAILS,
        payload: result?.data?.statusCode === 200 ? decryptedData : [],
      });
    }
  } catch (err) {}
};

const otbsUpdateCourseExamdetailsCreation = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  // const encodedData = yield call(handleEncodeJson, { encodeJSON: payload?.data });
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/venuedata/scheduler`, payload?.data)
    );
    if (result) {
      yield put({
        type: candidatesActions.GET_COURSE_ACTIVE_TAB,
        payload: {
          data: {
            courseid: payload?.data?.courseid,
          },
        },
      });
      yield put({
        type: candidatesActions.GET_CURRENT_VENUE_DETAILS,
        payload: {
          courseid: payload?.data?.courseid,
          candidateid: payload?.data?.candidateid,
        },
      });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
    if (result?.data?.statusCode === 200) {
      navigate(
        `/${localStorage.getItem("mhet_cnd_project")}/course-registration?page=${
          payload.nextPageName
        }`,
        {
          state: {
            courseid: payload?.data?.courseid,
            coursename: payload?.data?.coursename,
          },
        }
      );
      // window.location.reload();
    }
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const downloadBrochure = function* (data) {
  const { payload } = data;
  const { courseid, coursename } = payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const candidateid = yield select(
      (state) => state?.authReducer?.candidateTokenDetails?.candidateid
    );
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/brochure/${encodeURIComponent(
          EncryptFunction(courseid)
        )}/${encodeURIComponent(EncryptFunction(candidateid))}`
        //  {responseType: 'blob'}
      )
    );
    if (result?.data?.statusCode === 200 && result?.data?.data.trim() != "") {
      yield call(downloadBase64, {
        base64: result?.data?.data,
        coursename: coursename,
        fileExtension: result?.data?.fileExtension,
      });
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: "Brochure Downloaded Successfully",
        },
      });
      // downloadBase64(result?.data, coursename);
    } else if (result?.data?.data.trim() == "") {
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Bochure not availabe for this course",
        },
      });
    } else {
      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  } catch (err) {}
};
const createDownloadLog = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/admitcard-download-log`,
        encryptedData
      )
    );
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};
const createscoreDownloadLog = function* (data) {
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  const { payload } = data;
  try {
    const encryptedData = yield call(handleEncodeJson, {
      encodeJSON: payload?.data,
    });
    yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/scorecard-download-log`,
        encryptedData
      )
    );
  } catch (err) {}
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const AdmitAndScorecardViewButtonClick = function* (data) {
  const { payload } = data;

  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/admit-score-card-view-click/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`,
        {
          click: payload?.clickType,
          ipAddress: payload?.ipAddress,
        }
      )
    );
  } catch (err) {}
};
const Freecourseregistration = function* (data) {
  const { payload } = data;

  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/candidate/course/registraton/free_course_reg/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
  } catch (err) {}
};
// const GetAdmitcardUrl = function* (data) {
//   const { payload } = data;
// const formData = new FormData();
// console.log(payload,"payload")
//     formData.append("docs", payload?.modifiedFile);

//   yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
//   yield delay(1000);
//   try {
//       const response = axios.post(
//         `${API_URL}/master/coursemanagement/docs/${payload?.candidateName}`,
//         formData
//       );
//       console.log(response,"response");
//       payload?.setfileUrl(response.data?.result)
//        yield put({
//       type: candidatesActions.SET_ADMITCARD_URL,
//       payload: response?.data?.statusCode === 200 ? response.data?.result : [],
//     });
//   } catch (err) {
//   }
// };
// const GetAdmitcardUrl = function* (data) {
//   const { payload } = data;
//   const { setfileUrl, setPreview,navigate,CourseId } = payload;
//   const formData = new FormData();

//   console.log(payload, setfileUrl, "payload");

//   formData.append("docs", payload?.modifiedFile);

//   yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
//   yield delay(1000);

//   try {
//     const response = yield call(
//       axios.post,
//       `${API_URL}/master/coursemanagement/docs/${payload?.candidateName}`,
//       formData
//     );

//     console.log(response, "response");

//     if (response?.data?.statusCode === 200) {
//       setfileUrl(response.data?.result);
//       setPreview(response.data?.result);
//       if (payload?.getUrl == 1) {
//         navigate(
//           `/${localStorage.getItem(
//             "mhet_cnd_project"
//           )}/admit-card?courseid=${EncryptFunction(CourseId)}`
//         );
//       } else {
//         navigate(
//           `/${localStorage.getItem(
//             "mhet_cnd_project"
//           )}/score-card?courseid=${EncryptFunction(CourseId)}`
//         );
//       }
//       yield put({
//         type: candidatesActions.SET_ADMITCARD_URL,
//         payload: response.data.result,
//       });
//     } else {
//       yield put({
//         type: candidatesActions.SET_ADMITCARD_URL,
//         payload: [],
//       });
//     }
//   } catch (err) {
//     console.error("Error uploading admit card:", err);
//   }
// };
const GetAdmitcardUrl = function* (data) {
  const { payload } = data;
  const { setfileUrl, setPreview, navigate, CourseId } = payload;
  const formData = new FormData();

  formData.append("docs", payload?.modifiedFile);
  formData.append("admitcardimage", payload?.image);
  formData.append("admitcardsignature", payload?.signature);
  formData.append("admitcardbarcode", payload?.barcode);

  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);

  try {
    const response = yield call(
      axios.post,
      `${API_URL}/master/coursemanagement/docs/${payload?.candidateName}`,
      formData,
      {
        responseType: "blob", // Important for handling binary responses
      }
    );

    // Create a blob URL for the received file
    const blob = new Blob([response.data], { type: "application/pdf" });
    const fileUrl = URL.createObjectURL(blob);

    setfileUrl(fileUrl);
    setPreview(fileUrl);

    if (payload?.getUrl == 1) {
      navigate(
        `/${localStorage.getItem(
          "mhet_cnd_project"
        )}/admit-card?courseid=${EncryptFunction(CourseId)}`
      );
    } else {
      navigate(
        `/${localStorage.getItem(
          "mhet_cnd_project"
        )}/score-card?courseid=${EncryptFunction(CourseId)}`
      );
    }

    yield put({
      type: candidatesActions.SET_ADMITCARD_URL,
      payload: fileUrl,
    });
  } catch (err) {
    console.error("Error uploading admit card:", err);
  }
};

const getCoursePersonalInformationDetails = function* (data) {
  console.log('called');
  
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/personal-information/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`
      )
    );
    console.log(result, "result");
    
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_PERSONAL_INFORMATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getCourseReservationDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/reservation-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_RESERVATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};

const getCourseAcademicDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/academic-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_ACADEMIC_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};


const getCourseExamCenterDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/examcenter-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_EXAMCENTER_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};


const getCourseEditingFacilityDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/editingfacility-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_EDITINGFACILITY_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};


const getCoursePaymentInformationDetails = function* (data) {
  const { payload } = data;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  const candidateid = yield select(
    (state) => state?.authReducer?.candidateTokenDetails?.candidateid
  );
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/candidate/course/registraton/payment-information-details/${encodeURIComponent(
          EncryptFunction(candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload.courseid))}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.result,
    });
    yield put({
      type: candidatesActions.SET_COURSE_PAYMENTINFORMATION_DETAILS,
      payload: result?.data?.statusCode === 200 ? decryptedData : [],
    });
  } catch (err) {}
};


export default candidatesSaga;
